import { render } from "./VnfNicsSelection.vue?vue&type=template&id=24bdd9ae&scoped=true"
import script from "./VnfNicsSelection.vue?vue&type=script&lang=js"
export * from "./VnfNicsSelection.vue?vue&type=script&lang=js"

import "./VnfNicsSelection.vue?vue&type=style&index=0&id=24bdd9ae&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.23.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24bdd9ae"]])

export default __exports__